
import { TicketInfo } from "@/Models/ticket";
import { defineComponent, PropType } from "vue";
import TicketText from "./TicketText.vue";

export default defineComponent({
  components: { TicketText },
  name: "TicketFlightInfo",
  props: {
    ticket: { type: Object as PropType<TicketInfo>, required: true },
  },
  setup(props) {
    const local = "en-US";
    const dateFormat = {
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
    };
    const upperData = [
      { text: props.ticket.passangerName, label: "Passanger", class: "passanger" },
      { text: props.ticket.flightNumber, label: "Flight", class: "flight" },
      {
        text: props.ticket.departure.toLocaleDateString(local, dateFormat),
        label: "Departs",
        class: "departs",
      },
      { text: props.ticket.seat, label: "Seat", class: "seat" },
      {
        text: props.ticket.arrival.toLocaleDateString(local, dateFormat),
        label: "Arrives",
        class: "arrives",
      },
    ];

    const lowerData = [
      { text: props.ticket.terminal, label: "Terminal", class: "terminal" },
      { text: props.ticket.gate, label: "Gate", class: "gate" },
      {
        text: props.ticket.boarding.toLocaleTimeString(local, {
          hour: "2-digit",
          minute: "2-digit",
        }),
        label: "Boarding",
        class: "boarding",
      },
    ];

    return {
      upperData,
      lowerData,
    };
  },
});
